<template>
    <div>
        <v-card-text>
            <banner-table
                preventDefault
                :items="banners"
                :options="pagination"
                @edit="editBannerDetails "/>
        </v-card-text>

        <right-panel
            ref="bannerDetailsPanel"
            :title="$t('bannerList.details.header')">
            <template v-slot:content="{ context }" >
                <banner-details-view
                    ref="bannerDetailsView"
                    :banner="context"/>
            </template>
            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onBannerSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </div>
</template>

<script>
import BannerTable from '@/components/tables/BannerTable'
import BannerDetailsView from '@/views/BannerDetailsView'
import RightPanel from '@/components/panels/RightPanel'

export default {
    name: 'BannerSettingListView',

    components: {
        BannerTable,
        BannerDetailsView,
        RightPanel
    },

    props: {
        value: {
            type: Number,
            default: 0
        },

        banners: {
            type: Array,
            default: () => []
        },

        type: {
            type: String,
            required: true
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            bookingDetailDrawer: false
        }
    },

    methods: {
        editBannerDetails (bannerItem) {
            this.$refs.bannerDetailsPanel.open({ ...bannerItem })
        },

        createBanner () {
            this.$refs.bannerDetailsPanel.open({
                isActive: true,
                type: this.type,
                bannerUrl: null
            })
        },

        async onBannerSave () {
            await this.$refs.bannerDetailsView.save()
            this.$refs.bannerDetailsPanel.close()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-tab {
    text-transform: none;
}
</style>
